// extracted by mini-css-extract-plugin
module.exports = {"List":"CustomSelect_List__hhsTG"};